import { Box, styled } from '@mui/material';
import { BoxProps } from '@mui/system';

const EditorContainer = styled(Box)<BoxProps>(() => ({
  position: 'relative',
  '& .ProseMirror': {
    fontSize: 14,
    fontWeight: 400,
    minHeight: '300px',
    padding: '16px 16px 24px',
    outline: 'none',
    '& .BulletList-root': {
      listStyleType: 'disc',
    },
    '& p': {
      margin: 0,
      fontSize: '14px',
      lineHeight: 1.5,
    },
    '& ul, & ol': {
      paddingLeft: '24px',
    },
    '& .link': {
      color: 'primary.main',
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '& h1': {
      fontSize: '24px',
      fontWeight: 600,
      margin: '1em 0 0.5em',
      lineHeight: 1.2,
    },
    '& h2': {
      fontSize: '20px',
      fontWeight: 600,
      margin: '1em 0 0.5em',
      lineHeight: 1.2,
    },
    '& h3': {
      fontSize: '16px',
      fontWeight: 600,
      margin: '1em 0 0.5em',
      lineHeight: 1.2,
    },
    '& blockquote': {
      borderLeft: '3px solid #ccc',
      margin: '1em 0',
      paddingLeft: '1em',
    },
    '&::selection, & *::selection': {
      background: '#b4d5fe',
    },
    '&::-moz-selection, & *::-moz-selection': {
      background: '#b4d5fe',
    },
  },
}));

export default EditorContainer;
